var SelectDisplayItem = /** @class */ (function () {
    function SelectDisplayItem(displayName, value, extraProps, selected) {
        if (selected === void 0) { selected = false; }
        this.displayName = displayName;
        this.value = value;
        this.extraProps = extraProps;
        this.selected = selected;
    }
    return SelectDisplayItem;
}());
export { SelectDisplayItem };
